export default {
    namespaced: true,
    state() {
        return {
            loginSuccessful: false,
        };
    },
    mutations: {
        setLoginStatus(state, status) {
            state.loginSuccessful = status;
        },
    },
    actions: {
        updateLoginStatus({ commit }, status) {
            commit('setLoginStatus', status);
        },
    },
};
